import React, { useState } from "react";
import NavbarTop from "../Components/NavbarTop";
import { ReactComponent as MailImg } from "../../assets/illustration/MailSent.svg";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/logo/radis.png";
import MainButton from "../../commonComponents/MainButton.js";

// REDUX
import { useDispatch } from "react-redux";
import { sendPasswordResetLink } from "../../redux/actions/authActions";

const ForgotPasswordPage = () => {
  const [emailAddress, setEmailAddress] = useState("");
  const navigate = useNavigate();

  // callback={async () => await sendSignInLinkEmail_rd({ "creds": creds, "navigate": navigate })}

  // REDUX
  const dispatch = useDispatch();
  const sendPasswordResetLink_rd = (item) => dispatch(sendPasswordResetLink(item));

  return (
    <>
      {/* <NavbarTop /> */}
      <div className="flex justify-center w-full h-full font-Poppins-Regular">
        <div className="bg-white h-[580px] w-[960px] mt-[120px] shadow-lg rounded-2xl">
          <div className="bg-white content-center h-[580px] w-[960px] rounded-2xl flex justify-center items-center">
            {/* <div className="relative space-y-4 flex justify-center w-[400px]"> */}
            {/* <Link to="/Home">
                                <MailImg className="absolute top-5 w-[350px]" />
                            </Link> */}

            <form action="" className="w-[290px]">
              <div className="email block ">
                <label className="font-Poppins-SemiBold">Adresse email</label>
                <p className="text-xs font-Poppins-Light mt-2">Renseignez votre adresse email.</p>
                <input
                  className="input mt-6 text-ms rounded-lg block border-[1px] border-[#BEC4C] font-Poppins-Regular border-gray-300 focus:border-pitch-black  py-3 px-3 w-full focus:outline-none "
                  type="email"
                  value={emailAddress}
                  onChange={(e) => setEmailAddress(e.target.value)}
                  placeholder="email@company.com"
                  autoComplete="email"
                />
              </div>

              <div class="flex items-center justify-center mt-8 h-[56px]">
                <MainButton disabled={true} title={"Envoyer"} navigate={navigate} callback={async () => await sendPasswordResetLink_rd({ emailAddress, navigate })} />
              </div>
            </form>

            {/* </div> */}
          </div>
          <img src={logo} alt="logo" className="absolute h-[320px] transparent left-[965px] top-[120px] opacity-30" />
        </div>
      </div>
    </>
  );
};

export default ForgotPasswordPage;
